// utils/notifications.js
import { toast } from "react-toastify";

export const notifySuccess = (message) => {
  toast.success(message);
};

export const notifyError = (message) => {
  toast.error(message);
};

// Example of other types of notifications:
export const notifyInfo = (message) => {
  toast.info(message);
};

export const notifyWarning = (message) => {
  toast.warn(message);
};
